module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABCUlEQVQ4je2UW2uDQBCFv13deENFmooEQqH//4eV0lyM8ZrV7UNabYglKe1jDyzMHGY+zsusMMYYfil7ziyrhrftgb4fRk9KyeNDROC7tyHGwGZX4LkOYTAtHKuGzbbA9xyEENeQvCjP28BJD2jdI1yo29PFsO57NrsCZcuzIQRxGCCMMebldUfbnS7i35JlSZyFIksTJECWJniuczcAwHMdsjQBQM4NrFdL4ihAKZvnpwylbOIoYL1azgJnIUKIj/fZT97dkJ/qH3Kt2dvJi4qm6dB6YJ8f0Xqgrlu+u9URYllTqPxQjvV2fwSg7QbabjqDr/NjFYU+Ss0Gu9JiYROH/tiLv/hP3gFxyF8iWWrgNQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/message-center/delate.png
// module id = 2Pw1
// module chunks = 1